import { FC } from 'react';
import { AllieSelect } from '../../../components';
import { FilterBarProps } from './FilterBar';
import { StyledFilterBarMobileContainer } from './FilterBar.styles';
import { getDisplayText } from './utils';

const namespace = 'filter-bar-mobile';

export const AllieFilterBarMobile: FC<FilterBarProps> = ({ filters, labelAll }) => {
  return (
    <StyledFilterBarMobileContainer>
      <div className={`${namespace}__container-item`}>
        {filters.map(({ label, getOptions, component, handleChange, selected }) => {
          const options = getOptions?.(labelAll);
          const displayText = getDisplayText(options || [], selected, labelAll);

          return (
            <div className={`${namespace}__item`}>
              {component || (
                <AllieSelect
                  className={`${namespace}__item__select`}
                  options={options || []}
                  color={{
                    backgroundColor: 'white',
                    allieColor: 'neutral-60',
                  }}
                  selectedText={displayText === labelAll ? label : displayText}
                  selected={selected}
                  placeholder={label}
                  onChange={handleChange}
                />
              )}
            </div>
          );
        })}
      </div>
    </StyledFilterBarMobileContainer>
  );
};
